var exports = {
  "z": "RadioGroup__jD6QNq",
  "k": "dialogContent__UEVw-A",
};

module.exports = exports;
